export const SOBJECT_PRODUCT = 'Product2'
export const SOBJECT_PRICEBOOK = 'Pricebook2'
export const SOBJECT_PRICEBOOK_ENTRY = 'PricebookEntry'